var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union (Stroke)",
    d: "M3.84736 14.8674C4.11035 15.1312 4.24204 15.4985 4.20654 15.8692C4.12699 16.7001 3.94377 17.5648 3.70846 18.3681C5.45208 17.9651 6.51697 17.4976 7.00102 17.2523C7.27578 17.1131 7.59227 17.0802 7.88978 17.16C8.71208 17.3805 9.58845 17.5 10.5 17.5C15.4945 17.5 19.25 13.9906 19.25 10C19.25 6.00943 15.4945 2.5 10.5 2.5C5.5055 2.5 1.75 6.00943 1.75 10C1.75 11.8351 2.52163 13.538 3.84736 14.8674ZM3.23112 19.7487C3.2227 19.7503 3.21427 19.752 3.20583 19.7537C3.09104 19.7763 2.97403 19.7986 2.85477 19.8204C2.6875 19.851 2.5158 19.8808 2.33965 19.9097C2.09088 19.9504 1.90046 19.6902 1.99872 19.458C2.06292 19.3064 2.12621 19.1474 2.18788 18.9826C2.22705 18.8779 2.26556 18.7708 2.30323 18.6618C2.30486 18.6571 2.30648 18.6524 2.3081 18.6476C2.61778 17.748 2.86996 16.7139 2.96223 15.7501C1.42883 14.2124 0.5 12.2011 0.5 10C0.5 5.16751 4.97715 1.25 10.5 1.25C16.0228 1.25 20.5 5.16751 20.5 10C20.5 14.8325 16.0228 18.75 10.5 18.75C9.47906 18.75 8.49385 18.6161 7.56605 18.3674C6.91671 18.6964 5.51792 19.2954 3.23112 19.7487Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e5ff1bc7665cfe50b2b690797e9048f9.svg";
export { ForwardRef as ReactComponent };